import type {ReactElement} from 'react';
import React from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {IconType} from '@Components/icon-v2/icon.types';
import {Type} from '@Components/button';
import {NavRightSideOptionTypes} from '@Components/poster-editor/components/poster-editor-nav-bar/components/nav-right-options/nav-right-options.types';
import {useAppSelector} from '@/hooks';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import styles from './nav-download-option.module.scss';
import {DownloadPanel} from '@Components/download-panel/download-panel';
import BaseNavOption from '@Components/poster-editor/components/poster-editor-nav-bar/components/base-nav-option/base-nav-option';
import {onOpenDownloadModal} from '@Components/poster-editor/library/poster-editor-open-modals';

interface NavDownloadOptionProps {
  downloadOptionType?: NavRightSideOptionTypes;
}

const SHOW_NEW_DOWNLOAD_PANEL = false;

export function NavDownloadOption({downloadOptionType = NavRightSideOptionTypes.BUTTON}: NavDownloadOptionProps): ReactElement {
  const isInitialized = useAppSelector((state) => {
    return state.posterEditor.posterObject?.isInitialized;
  });

  const getDownloadSelector = (): ReactElement => {
    return (
      <div>
        <BaseNavOption
          id="nav-download-option"
          icon="icon-download"
          text={window.i18next.t('pmwjs_download')}
          optionType={downloadOptionType}
          iconType={IconType.DARK_SECONDARY}
          buttonType={Type.DARK_SECONDARY}
          hasMarginRight
          isLoading={!isInitialized}
          onClickHandler={(): void => {
            if (!SHOW_NEW_DOWNLOAD_PANEL) {
              onOpenDownloadModal();
            }
          }}
        />
      </div>
    );
  };

  // const getPopup = (): ReactElement => {
  //   const posterObject = window.posterEditor?.whiteboard?.toObject();
  //   return <DownloadPanel id="editor-download-panel" posterObject={posterObject} />;
  // };
  //
  // if (SHOW_NEW_DOWNLOAD_PANEL) {
  //   return (
  //     <Dropdown
  //       popUpHasCustomWidth
  //       maxHeight={602}
  //       popupSpacingClass="spacing-p-0"
  //       topOffset={-5}
  //       leftOffset={-10}
  //       doCloseOnInnerClick={false}
  //       position={DROPDOWN_POSITION.FIXED}
  //       popupClassName={`${styles.popup} _overflow-hidden`}
  //       selector={getDownloadSelector()}
  //       popup={getPopup()}
  //       alignment={ALIGNMENT_TYPE.BOTTOM_END}
  //     />
  //   );
  // }

  return getDownloadSelector();
}
